import React from 'react';
import { DeleteButton } from 'admin-on-rest';

const DeleteButtonWithPermission = ({ resource, path, permissions, ...props }) => (
  permissions.delete ? <DeleteButton {...props} resource={resource} basePath={path || props.basePath} /> : null
);

export default DeleteButtonWithPermission;
